module.exports = __webpack_public_path__ + "img/banner-mobile.064fce6a.png";